<template>
  <div class="markup_list" v-loading="loading">
    <div class="markup_tit" v-if="list.length">
      <span class="markup_info">加价信息</span
      ><span class="handle_info">操作</span>
    </div>
    <div>
      <div class="markup_main" v-for="item in list">
        <el-row class="markup_info rows">
          <div class="chulizhuangt">
            <div style="color: #ffad16">
              {{ setStatus(item.status) || "/" }}
            </div>
            <div class="duohang" v-if="item.status == 'REJECT'">
              <span>{{ item.dealTime }}</span>
              {{ item.rejectContent }}
            </div>
            <div class="duohang" v-if="item.status == 'SUCCESS'">
              <span>{{ item.dealTime }}</span>
              支付方式 （{{ setPayStatus(item.payWay) }}：￥{{ item.amount }}）
            </div>
            <div
              class="duohang"
              v-if="item.status == 'CLOSE' || item.status == 'WAIT_PAY'"
            >
              暂无数据
            </div>
          </div>
          <el-col :span="6"
            >申请金额：<span style="color: #f75658"
              >¥{{ item.amount || 0 }}</span
            ></el-col
          >
          <el-col :span="6"
            >申请时间：<span>{{ item.createTime }}</span></el-col
          >
          <el-col :span="5"
            >加价类型：<span>{{ item.type_dictText || "/" }}</span></el-col
          >
          <el-col :span="7" class="call"
            >申请人：<span>{{ item.createBy }} {{ item.createPhone }}</span>
            <el-button @click="openCallModal(item)">站内电话</el-button></el-col
          >
          <el-col :span="24" class="row"
            >加价原因：<span>{{ item.content || "/" }}</span></el-col
          >
        </el-row>
        <div class="handle_info">
          <div v-if="item.status == 'WAIT_PAY'">
            <div>
              <el-button type="primary" @click="onPay(item)"
                >确认支付</el-button
              >
              <el-button @click="onReject(item)">驳回</el-button>
            </div>
            <div class="yichang" v-if="item.orderAbnormalId">
              <el-button @click="goAbnormalInfo">异常详情</el-button>
            </div>
          </div>
          <div v-if="item.status == 'SUCCESS'">
            <div class="yichang">/</div>
          </div>
          <div v-if="item.status == 'REJECT' || item.status == 'CLOSE'">
            <div class="yichang">
              <el-button v-if="item.orderAbnormalId" @click="goAbnormalInfo"
                >异常详情</el-button
              >
              <span>/</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="null-info" v-if="list.length === 0">
      <img src="@/assets/img/pic_none.png" alt />
      暂无信息...
    </div>
    <reject-modal ref="rejectModal" @ok="getMarkupList"></reject-modal>
    <videoCall-modal ref="videoCallModal"></videoCall-modal>
    <markup-pay ref="markupPay" @ok="getMarkupList"></markup-pay>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import rejectModal from "./rejectModal";
import videoCallModal from "./videoCallModal";
import markupPay from "@/components/order/markupPay";

export default {
  props: {
    orderId: {
      type: String,
      default: "",
    },
  },
  components: {
    rejectModal,
    videoCallModal,
    markupPay,
  },
  data() {
    return {
      list: [],
      payStatus: [
        { name: "未处理", value: "WAIT_PAY" },
        { name: "已支付", value: "SUCCESS" },
        { name: "已驳回", value: "REJECT" },
        { name: "已取消", value: "CLOSE" },
      ],
      loading: false,
    };
  },
  watch: {
    orderId(val) {
      if (val) this.getMarkupList();
    },
  },
  methods: {
    goAbnormalInfo() {
      this.$parent.orderTab.map((i) => {
        i.isSelected = false;
      });
      this.$parent.orderTab[4].isSelected = true;
    },
    // 驳回
    onReject(item) {
      this.$refs.rejectModal.init(item);
    },
    // 确认支付
    onPay(item) {
      this.$refs.markupPay.init(item);
    },
    // 站内电话
    openCallModal(item) {
      Object.assign;
      this.$refs.videoCallModal.init(
        Object.assign(item, {
          orderType: "applicant",
        })
      );
    },
    // 获取加价申请
    getMarkupList() {
      this.loading = true;
      getAction(`/order/api/markup/${this.orderId}/list`)
        .then(({ data }) => {
          console.log(data);
          if (data.code == 0) {
            this.list = data.data;
          }
        })
        .finally(() => (this.loading = false));
    },
    setStatus(status) {
      for (let i of this.payStatus) {
        if (i.value == status) return i.name;
      }
    },
    setPayStatus(status) {
      if (status == "WALLET") return "钱包";
      else if (status == "ALIPAY") return "支付宝";
      else if (status == "WECHAT") return "微信";
      else return "/";
    },
  },
};
</script>

<style lang='scss' scoped>
.markup_list {
  .markup_tit {
    display: flex;
    height: 36px;
    background: #f9fafa;
  }
  .markup_info,
  .handle_info {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    &.rows {
      justify-content: flex-start;
      /deep/.el-col {
        color: #5e6066;
        font-size: 12px;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          color: #2f3133;
        }
      }
      .call {
        position: relative;
        /deep/.el-button {
          position: absolute;
          right: 10px;
          top: calc(50% - 14px);
          font-size: 12px;
          :hover {
            color: #3455d3 !important;
          }
        }
      }
      .row {
        display: flex;
        span {
          width: 92%;
        }
      }
    }
  }
  .markup_info {
    // width: 860px;
    width: 924px;
  }
  .handle_info {
    width: 180px;
  }
  .markup_main {
    // padding: 20px;
    background: #fff;
    display: flex;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .markup_info {
      padding: 20px;
      border-right: 1px solid #e8eef5;
    }
  }
  .chulizhuangt {
    display: flex;
    background: #fafafc;
    width: 100%;
    min-height: 40px;
    padding: 11px 12px;
    font-size: 12px;
    margin-bottom: 20px;
    // margin-right: 10px;
    & > div:first-child {
      padding-right: 6px;
      margin-right: 15px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        height: 12px;
        width: 1px;
        background: #d8d8d8;
        right: 0;
        top: 4px;
      }
    }
    .duohang {
      width: 92%;
    }
  }
  .handle_info {
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/.el-button {
      font-size: 12px;
      &.el-button--default {
        color: #5e6066 !important;
      }
    }
    & > div:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
    }
    .yichang {
      margin-top: 8px;
    }
  }
}
.null-info {
  background: #fff;
  padding: 30px 261px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #b4b7bc;
  margin-top: 15px;

  img {
    width: 375px;
    height: 94px;
    margin-bottom: 8px;
  }
}
</style>
